import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FieldType, FieldTypeConfig, FormlyModule } from "@ngx-formly/core";
import { TranslateModule } from "@ngx-translate/core";

export interface SelectOption {
  value: string | number;
  label: string;
}

/**
 * Custom Formly field type for select dropdowns.
 */
@Component({
  selector: "app-formly-form-select",
  standalone: true,
  imports: [ReactiveFormsModule, TranslateModule, FormlyModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: "d-block" },
  template: `
    <div [class]="props['formGroupClass'] || 'form-group'">
      @if (props.label) {
      <label [attr.for]="id">{{ props.label | translate }}</label>
      }
      <select
        class="form-control"
        [id]="id"
        [formControl]="formControl"
        [formlyAttributes]="field"
      >
        @for (option of selectOptions; track option.value) {
        <option [value]="option.value">
          {{ option.label | translate }}
        </option>
        }
      </select>
    </div>
  `,
})
export class FormSelectFieldComponent extends FieldType<FieldTypeConfig> {
  override defaultOptions = {
    props: {
      options: [] as SelectOption[],
    },
  };

  get selectOptions(): SelectOption[] {
    return Array.isArray(this.props.options) ? this.props.options : [];
  }
}
